import { render, staticRenderFns } from "./BasketProduct.vue?vue&type=template&id=4c0e8d6b&scoped=true"
import script from "./BasketProduct.vue?vue&type=script&lang=js"
export * from "./BasketProduct.vue?vue&type=script&lang=js"
import style0 from "./BasketProduct.vue?vue&type=style&index=0&id=4c0e8d6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0e8d6b",
  null
  
)

export default component.exports